export class EconomySystem {
  gold = 180;
  objectivePoints = 0;
  incomeLevel = 0;
  activeUnitCount = 0;
  economyOutpostCount = 0;
  investmentIncomePerSecond = 0;
  private incomeAccumulator = 0;

  get incomePerSecond() {
    return 7 + this.incomeLevel * 3;
  }

  get upkeepPenaltyPercent() {
    if (this.activeUnitCount <= 14) return 0;
    if (this.activeUnitCount <= 24) return Math.min(55, (this.activeUnitCount - 14) * 3);
    return Math.min(55, 30 + (this.activeUnitCount - 24) * 5);
  }

  get upkeepMultiplier() {
    return Math.max(0.45, 1 - this.upkeepPenaltyPercent / 100);
  }

  get outpostIncomeMultiplier() {
    return 1 + this.economyOutpostCount * 0.08;
  }

  get effectiveIncomePerSecond() {
    return Number((this.incomePerSecond * this.upkeepMultiplier * this.outpostIncomeMultiplier + this.investmentIncomePerSecond).toFixed(2));
  }

  get incomeUpgradeCost() {
    return this.incomeLevel >= 6 ? Infinity : 115 + this.incomeLevel * 85;
  }

  update(deltaMs: number, activeUnitCount = this.activeUnitCount) {
    this.activeUnitCount = activeUnitCount;
    this.incomeAccumulator += deltaMs;
    while (this.incomeAccumulator >= 1000) {
      this.gold += this.effectiveIncomePerSecond;
      this.incomeAccumulator -= 1000;
    }
  }

  canAfford(cost: number) {
    return this.gold >= cost;
  }

  spend(cost: number) {
    if (!this.canAfford(cost)) {
      return false;
    }
    this.gold -= cost;
    return true;
  }

  reward(amount: number) {
    this.gold += amount;
  }

  upgradeIncome() {
    const cost = this.incomeUpgradeCost;
    if (!Number.isFinite(cost) || !this.spend(cost)) return false;
    this.incomeLevel += 1;
    return true;
  }

  addObjectivePoints(amount: number) {
    this.objectivePoints += amount;
  }
}
